import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { UiModalService } from "../../ui/ui-modal.service";

@Injectable() 
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private modalService: UiModalService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    // MARK: Implement a strategy!
                    // this.modalService
                    //     .showModalError('HTTP Error', `<p>Status Code: ${error.status}<br>Message: ${error.message}`);
                    
                    console.error(`HEI -> HttpError Occured: ${error.status} ${error.statusText}`, error);
                    return throwError(() => error);
                })
            );
    }
}